import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Pagination, PaginationSizeFilter } from "../components/commonComponents/Pagination";
import httpService from "../api-services/httpService";
import { toast } from "react-toastify";


function Row(props) {
    const { row } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCell align="center" className="tableCell">{row?.rank}</TableCell>
                <TableCell align="center" className="tableCell">{row?.username}</TableCell>
                <TableCell align="center" className="tableCell">{row?.userId}</TableCell>
                <TableCell align="center" className="tableCell">{row?.score}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

const LeaderboardPage = () => {
    const [leaderboardData, setLeaderboardData] = useState();

    const [page, setPage] = useState(1);
    const [size, setSize] = useState(5);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        const getLeaderboardData = async () => {
            try {
                const res = await httpService.get(`/leaderboard/getLeaderboard?page=${page}&size=${size}`);
                if (res) {
                    setLeaderboardData(res?.data);
                    setTotal(res?.data?.totalCount)
                }
            } catch (error) {
                toast.error(error, 5000);
            }
        }
        getLeaderboardData();
    }, [page, size])

    const handleSizeChange = (event) => {
        setSize(parseInt(event.target.value, 10));
        setPage(1);
    };

    const handlePageChange = (change) => {
        if (change && page < Math.ceil(+total / +size)) {
            setPage((prev) => prev + 1);
        } else if (!change && page > 1) {
            setPage((prev) => prev - 1);
        }
    };


    return (
        <StyledDiv>
            <TableContainer component={Paper} className="tableBox">

                <Table aria-label="collapsible table">
                    <TableHead className="tableHead">
                        <TableRow>
                            <TableCell align="center" className="tableCell">Rank</TableCell>
                            <TableCell align="center" className="tableCell">Username</TableCell>
                            <TableCell align="center" className="tableCell">UserID</TableCell>
                            <TableCell align="center" className="tableCell">Total Score</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className="tableBody">
                        {leaderboardData?.data?.map((row, i) => (
                            <Row key={row._id} row={row} />
                        ))}
                    </TableBody>
                </Table>
                <div className="paginationBox">
                    <PaginationSizeFilter
                        size={size}
                        handleSizeChange={handleSizeChange}
                    />
                    <Pagination
                        total={total}
                        size={size}
                        page={page}
                        handlePageChange={handlePageChange}
                        setPage={setPage}
                    />
                </div>
            </TableContainer>
        </StyledDiv>
    );
}

export default LeaderboardPage;


const StyledDiv = styled.div`
margin: 2rem 0% 2rem 0%;
width: 100%;
padding: 0 0%;
flex-direction: column;
align-items: center;
border: 0.1rem solid var(--color);
border-radius: 0.5rem;

.tableBox {
    background-color: var(--background-color);
}

.paginationBox {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 2rem;
    margin: 2rem 5rem 2rem 0;
  }

.tableHead {
  background-color: var(--background-color);
  width: 100%;

  .tableCell {
    font-size: 1.5rem;
    font-weight: 600;
    font-family: var(--font);
    color: var(--color);
  }
  
}

.tableBody {
  background-color: var(--background-color);
  width: 100%;

  .tableCell {
    font-size: 1.5rem;
    font-weight: 400;
    font-family: var(--font);
    color: var(--color);
  }
}

`
